import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone"
import { Badge, IconButton } from "@mui/material"
import { type FC, useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "../../app/hooks"
import { ModeContext } from "../../ModeContext"
import { InAppFeedDrawer } from "./InAppFeedDrawer"
import { selectFeedUnreadIds } from "./inAppMessagesSlice"

/**
 * The What's-new bell (LOCKER-485). Standalone only: spec R17 keeps the feed out of
 * embedded and RxPro mode. The badge counts unread feed items and hides at 0.
 */
export const InAppFeedBell: FC = () => {
  const { t } = useTranslation()
  const mode = useContext(ModeContext) || "standalone"
  const unread = useAppSelector(selectFeedUnreadIds).length
  const [open, setOpen] = useState(false)

  if (mode !== "standalone") return null
  return (
    <>
      <IconButton
        data-ui="UI-SL2W-289"
        aria-label={t("inAppFeedTitle")}
        title={t("inAppFeedTitle")}
        onClick={() => setOpen(true)}
      >
        <Badge badgeContent={unread} color="error" data-testid="inAppFeedBadge">
          <NotificationsNoneIcon sx={{ color: "primary.main" }} />
        </Badge>
      </IconButton>
      <InAppFeedDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
